/*eslint no-undef: "error"*/
<template>
  <div>
    <v-nav nav-class="purple darken-4" v-if="mostrarNav">
      <a href="https://pedidos.guepardos.co" class="brand-logo" slot="logo">
        <img class="responsive-img" src="../assets/logo-nuevo.png" width="55" style="padding-top: 5px;" />
      </a>
      <ul class="left hide-on-small-only">
        <li>
          <a href="https://pedidos.guepardos.co" class="hide-on-small-only" style="padding-left:75px; font-size:29px;">Guepardos</a>
        </li>
      </ul>
      <ul class="right">
        <li>
          <a href="#!" v-side-nav:demo="nav" v-if="mostrarNav">
            <i class="material-icons dp48">apps</i>
          </a>
        </li>
      </ul>
    </v-nav>
    <div class="marker" v-if="!mostrarNav">
      <ul class="rigth">
        <li>
          <a href="#!" v-side-nav:demo="nav" class="sizeA stroke">
            <i class="material-icons dp48 fa-3x">apps</i> <br>
            <span style="margin-left: -30px;">Detalle Servicio</span>
          </a>
        </li>
      </ul>
    </div>
    <div>
      <v-side-nav id="demo">
        <h5 class="center-align">¡Detalles del Servicio!</h5>
        <div class="col-md-12">
          <ul class="collection">
            <li class="collection-item"><strong><i class="fa fa-calendar" aria-hidden="true"></i> Estado: </strong> {{ estado }}</li>
            <li class="collection-item" v-if="servicio.estadoServicio === 3"><strong>Calificación: </strong><star-rating v-model="rating" @rating-selected="setRating" :star-size="20"></star-rating></li>
            <li class="collection-item" v-if="showComment && servicio.estadoServicio === 3"><strong>Comentario:</strong><textarea v-model="comentario" cols="30" rows="10"></textarea></li>
            <li class="collection-item"><strong><i class="fa fa-id-card-o" aria-hidden="true"></i> ID: </strong> {{ id }}</li>
            <li class="collection-item"><strong><i class="fa fa-user" aria-hidden="true"></i> Nombre: </strong> {{ servicio.nombre }}</li>
            <li class="collection-item"><strong><i class="fa fa-envelope" aria-hidden="true"></i> Recogida: </strong> {{ servicio.recogida }}</li>
            <li class="collection-item"><strong><i class="fa fa-retweet" aria-hidden="true"></i> Ida y Regreso: </strong> <span v-if="servicio.idaVuelta">Si</span> <span v-if="!servicio.idaVuelta">No</span></li>
            <li class="collection-item"><strong><i class="fa fa-list-alt" aria-hidden="true"></i> Descripción: </strong> {{ servicio.descripcion }}</li>
            <li class="collection-item" v-if="!isAdmin"><strong><i class="fa fa-arrows-h" aria-hidden="true"></i> Distancia: </strong> {{ distancia }} Km</li>
            <li class="collection-item" v-if="isAdmin && showDistancia"><strong><i class="fa fa-arrows-h" aria-hidden="true"></i> Distancia Operador: </strong> {{ servicio.tarifa.distancias.operador }} Km</li>
            <li class="collection-item" v-if="isAdmin && showDistancia"><strong><i class="fa fa-arrows-h" aria-hidden="true"></i> Distancia Usuario: </strong> {{ servicio.tarifa.distancias.usuario }} Km</li>
            <li class="collection-item" v-if="isAdmin && showDistancia"><strong><i class="fa fa-arrows-h" aria-hidden="true"></i> Distancia Mensajero: </strong> {{ servicio.tarifa.distancias.mensajero }} Km</li>
            <li class="collection-item"><strong><i class="fa fa-money" aria-hidden="true"></i> Valor: </strong>$ {{ parseInt(servicio.valor) }}</li>
            <li class="collection-item" v-bind:class="{ 'colorVerde': showKm }" v-if="isAdmin"><strong><i class="fa fa-money" aria-hidden="true"></i> Valor Km: </strong>$ {{ parseInt(valorKm) }}</li>
            <li class="collection-item" v-bind:class="{ 'colorVerde': showRd }" v-if="isAdmin"><strong><i class="fa fa-money" aria-hidden="true"></i> Valor Radios: </strong>$ {{ parseInt(valorRadios) }}</li>
            <li class="collection-item"><strong><i class="fa fa-clock-o" aria-hidden="true"></i> Tiempo: </strong> {{ tiempoServicio }}</li>
            <li class="collection-item"><strong><i class="fa fa-motorcycle" aria-hidden="true"></i> Mensajero: </strong> {{ mensajeroNombre }} - {{ mensajeroCelular }}</li>
            <li class="collection-item">
              <strong> <i class="fa fa-truck" aria-hidden="true"></i> Entregas: {{ entregasSinRegresos }}</strong> </span>
              <ul class="collection" v-if="servicio.entrega == 'Multientrega'">
                <li class="collection-item" v-for="item in entregasDirecciones" :key="item.index" @click="toggleInfoWindow(item, item.index)">{{ item.direccion }}</li>
              </ul>
              <ul class="collection" v-if="servicio.entrega != 'Multientrega'">
                <li class="collection-item">{{ servicio.entrega }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </v-side-nav>
      <gmap-map :center="center" ref="myMap" :options="{streetViewControl: false}" :zoom="zoom" v-bind:class="{ 'conNav': conNav, 'sinNav': sinNav }">
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false"></gmap-info-window>
        <gmap-marker
        :key="i"
        v-for="(m, i) in markers"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      <gmap-marker
        :key="i"
        v-for="(m, i) in mensajeros"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      <gmap-circle
        :key="i + 'circle'"
        v-for="(c, i) in circles"
        :center="c.center" :radius="c.radius" :options="{fillOpacity: 0.0, strokeColor:'#F26E64', fillColor:'#F26E64'}">
      </gmap-circle>
      </gmap-map>
    </div>
    <notifications group="foo" position="bottom left" />
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import router from '../router'
import moment from 'moment'
import axios from 'axios'
import StarRating from 'vue-star-rating'
import _ from 'lodash'
import { loaded } from 'vue2-google-maps'
export default {
  name: 'servicio',
  data () {
    return {
      nav: {
        edge: 'right'
      },
      GET_SERVICE_URL: 'https://mensajeria.guepardos.co/api/v2/services/',
      Url_Mensajeros: 'https://mensajeria.guepardos.co/api/v2/messengersPositions',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      zoom: 14,
      rating: 0,
      comentario: '',
      showDistancia: false,
      infoWinOpen: false,
      currentMidx: null,
      showPrecios: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      servicio: {},
      mensajero: {},
      mensajeroNombre: '',
      mensajeroCelular: '',
      noDibujar: false,
      recogido: [],
      entregas: [],
      finalizado: [],
      waypts: [],
      lastPosition: [],
      mensajeros: [],
      mensajerosData: [],
      makersToRemove: [],
      totalEntregas: 0,
      kilometrosCirculo: 2.5,
      entregasDirecciones: [],
      estado: '',
      id: '',
      infoText: '',
      dibujarCirculos: true,
      circles: [],
      mostrarMensajeRecogida: true,
      mostrarNav: true,
      marcarRuta: true,
      quitarRadios: false,
      valorRadios: 0,
      valorKm: 0,
      distancia: 0,
      showKm: false,
      showRd: false,
      conNav: false,
      sinNav: false,
      isAdmin: false,
      showComment: false,
      formatNumber: {
        separador: '.', // separador para los miles
        sepDecimal: ',', // separador para los decimales
        formatear (num) {
          num += ''
          let splitStr = num.split('.')
          let splitLeft = splitStr[0]
          let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : ''
          let regx = /(\d+)(\d{3})/
          while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2')
          }
          return this.simbol + splitLeft + splitRight
        },
        new (num, simbol) {
          this.simbol = simbol || ''
          return this.formatear(Math.round(num / 100) * 100)
        }
      }
    }
  },
  mounted () {
    this.mensajero.nombre = ''
    if (this.$route.query.adm) {
      this.isAdmin = JSON.parse(this.$route.query.adm)
    }
    if (this.$route.query.nav) {
      this.mostrarNav = JSON.parse(this.$route.query.nav)
      this.sinNav = true
      this.conNav = false
    } else {
      this.sinNav = false
      this.conNav = true
    }
    this.getData()
    this.interval = setInterval(function () {
      this.getData()
    }.bind(this), 10000)
  },
  methods: {
    getData () {
      let vm = this
      vm.$http.get(`https://mensajeria.guepardos.co/api/v2/services/${vm.$route.params.id}`)
        .then(data => {
          if (data.body.error) {
            vm.$http.get(`https://mensajeria.guepardos.co/api/v2/servicio-ticket/${vm.$route.params.id}`)
            .then(data => {
              this.getDataExtra(data)
            })
          } else {
            this.getDataExtra(data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDataExtra (data) {
      let vm = this
      vm.servicio = data.body
      loaded.then(() => {
        this.$refs.myMap.$mapCreated.then(() => {
          let src = 'http://storage.googleapis.com/gpds-geo-zonas/AreaMetroMensajeriaMapa.kml'
          if (vm.servicio.compartido || vm.servicio.agrupado) {
            src = 'https://storage.googleapis.com/gpds-geo-zonas/MunicipiosDelAreaMetro.kml'
            let MarkerWithLabel = require('markerwithlabel')(google.maps)
            let medellin = new google.maps.LatLng(6.247389415831316, -75.58053604236915)
            let markerPriceMedellin = new MarkerWithLabel({
              position: medellin,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(5800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: {opacity: 1}
            })
            let envigado = new google.maps.LatLng(6.171625973057168, -75.58403263540202)
            let markerPriceEnvigado = new MarkerWithLabel({
              position: envigado,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(5800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: {opacity: 1}
            })
            let itagui = new google.maps.LatLng(6.186495802555004, -75.6046181705226)
            let markerPriceItagui = new MarkerWithLabel({
              position: itagui,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(5800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: {opacity: 1}
            })
            let sabaneta = new google.maps.LatLng(6.152991088357088, -75.6167556269836)
            let markerPriceSabaneta = new MarkerWithLabel({
              position: sabaneta,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(6800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            })
            let estrella = new google.maps.LatLng(6.135811030451446, -75.63579718679)
            let markerPriceEstrella = new MarkerWithLabel({
              position: estrella,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(11600),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            })
            let caldas = new google.maps.LatLng(6.088932375769244, -75.63519446322465)
            let markerPriceCaldas = new MarkerWithLabel({
              position: caldas,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(11600),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            })
            let sanAntonio = new google.maps.LatLng(6.183530968697657, -75.65517574307182)
            let markerPriceSanAntonio = new MarkerWithLabel({
              position: sanAntonio,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(11600),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            })
            let bello = new google.maps.LatLng(6.337490251683754, -75.5610933553238)
            let markerPriceBello = new MarkerWithLabel({
              position: bello,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(6800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            })
            let copacabana = new google.maps.LatLng(6.354739962376049, -75.50292838529327)
            let markerPriceCopacabana = new MarkerWithLabel({
              position: copacabana,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(11600),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            })
          }
          let kmlLayer = new google.maps.KmlLayer(src, {
            suppressInfoWindows: true,
            preserveViewport: true,
            map: vm.$refs.myMap.$mapObject
          })
        })
      })
      vm.id = this.servicio.id.substr(-6)
      vm.finalizado = vm._.find(vm.servicio.fechaHoraEstados, function (o) { if (o.estado === 3) { return o } })
      if (vm.finalizado) {
        clearInterval(vm.interval)
      }
      vm.dibujarPuntos()
      vm.$http.get(`https://mensajeria.guepardos.co/api/v2/menssengerService/${vm.$route.params.id}`)
        .then(data => {
          vm.mensajero = data.body
          vm.mensajeroNombre = vm.mensajero.nombre
          vm.mensajeroCelular = vm.mensajero.celular
          vm.$http.get(`https://mensajeria.guepardos.co/api/v2/messengerPosition/${vm.servicio.mensajeroId}`)
          .then(data => {
            if (data.body.length > 0) {
              vm.lastPosition = data.body[0].metadata.coords
            }
          })
        })
      vm.$http.get('https://mensajeria.guepardos.co/api/v2/messengersPositions')
      .then(data => {
        console.log(data.body)
        vm.mensajerosData = data.body
      })
    },
    dibujarPuntos () {
      let vm = this
      vm.$refs.myMap.$mapCreated.then(function () {
        vm.markers = []
        vm.dibujarRecogida(vm.servicio.geoR.lat, vm.servicio.geoR.lng)
        vm.recogido = vm._.find(vm.servicio.fechaHoraEstados, function (o) { if (o.estado === 1) { return o } })
        vm.dibujarRegresos(vm._.filter(vm.servicio.fechaHoraEntregas, function (o) { return o.regreso }))
        if (vm.servicio.calificacion) {
          vm.rating = vm.servicio.calificacion
          vm.showComment = true
          if (vm.servicio.comentarioCalificacion) {
            vm.comentario = vm.servicio.comentarioCalificacion
          }
        }
        if (!vm.servicio.tarifa.distancias) {
          vm.servicio.tarifa.distancias = {
            usuario: 0,
            mensajero: 0,
            operador: 0
          }
        }
        vm.showDistancia = true
        if (vm.servicio.distancia && vm.servicio.distancia !== 0) {
          vm.distancia = vm.servicio.distancia
        } else {
          vm.showDistancia = true
          if (vm.servicio.tarifa.distancias.usuario && vm.servicio.tarifa.distancias.usuario !== 0) {
            vm.distancia = vm.servicio.tarifa.distancias.usuario
          } else {
            if (vm.servicio.tarifa.distancias.mensajero && vm.servicio.tarifa.distancias.mensajero !== 0) {
              vm.distancia = vm.servicio.tarifa.distancias.mensajero
            } else {
              vm.distancia = 0
            }
          }
        }
        if (vm.recogido) {
          vm.mostrarMensajeRecogida = false
        }
        vm.entregasDirecciones = []
        let entregas = []
        if (vm.servicio.entregasMapa) {
          entregas = vm.servicio.entregasMapa
        } else {
          entregas = vm.servicio.fechaHoraEntregas.filter(item => !item.regreso)
        }
        vm._.forEach(vm.servicio.fechaHoraEntregas, function (entrega, index) {
          if (!entrega.regreso) {
            let fecha = moment(entrega.fecha).format('HH:mm:ss')
            let valor = 0
            if (entrega.valor) {
              valor = `$${entrega.valor}`
            }
            vm.markers.push({
              position: {
                lat: parseFloat(entrega.coordenadas.latitude),
                lng: parseFloat(entrega.coordenadas.longitude)
              },
              infoText: `Entrega ${index + 1} - ${fecha} - ${valor}`,
              icon: require('../assets/entrega.png')
            })
          }
        })
        vm._.forEach(vm.markers, function (marker, index) {
          if (index >= 1) {
            marker.direccion = `Entrega ${index}`
            marker.index = index
            vm.entregasDirecciones.push(marker)
          }
        })
        vm.distancia = vm.servicio.tarifa.distancia
        vm.valorKm = vm.servicio.tarifa.valorKm
        switch (vm.servicio.estadoServicio) {
          case 99:
            vm.estado = 'Pendiente'
            console.log('dsfsdfasdfsdfdsadfdsafdsa')
            vm.dibujarMensajeros()
            break
          case 0:
            vm.estado = 'Asignado'
            vm.dibujarMensajeroAsignado()
            if (vm.mostrarMensajeRecogida) {
              vm.$notify({
                group: 'foo',
                title: 'Información',
                type: 'warning',
                text: 'El servicio ha sido asigando y está en proceso de ser recogido.',
                duration: -1
              })
            }
            vm.mostrarMensajeRecogida = false
            break
          case 1:
            vm.estado = 'Recogido'
            vm.dibujarMensajeroAsignado()
            vm.$notify({
              group: 'foo',
              clean: true
            })
            break
          case 2:
            vm.estado = 'Entregado'
            vm.dibujarMensajeroAsignado()
            vm.$notify({
              group: 'foo',
              clean: true
            })
            break
          case 3:
            vm.estado = 'Finalizado'
            vm.mensajeros = []
            vm.showPrecios = true
            if (vm.marcarRuta) {
              vm.getRoute()
              vm.obtenerDirecciones()
            }
            vm.$notify({
              group: 'foo',
              clean: true
            })
            break
          case 4:
            vm.estado = 'Cancelado'
            vm.mensajeros = []
            vm.$notify({
              group: 'foo',
              clean: true
            })
            break
          default:
            vm.estado = 'Pendiente'
            break
        }
      })
    },
    dibujarRegresos (regresos) {
      let vm = this
      vm._.forEach(regresos, function (regreso, index) {
        vm.markers.push({
          position: {
            lat: regreso.coordenadas.latitude,
            lng: regreso.coordenadas.longitude
          },
          infoText: `Regreso ${index + 1}`,
          icon: require('../assets/regreso.png')
        })
      })
    },
    dibujarRecogida (lat, lng, tipo, fecha) {
      let fechaFormat = moment(fecha).format('HH:mm:ss')
      let vm = this
      if (tipo) {
        vm.infoText = `Punto de Recogida - ${fechaFormat}`
      } else {
        vm.infoText = `Recogida - ${fechaFormat}`
      }
      vm.markers.push({
        position: {
          lat: lat,
          lng: lng
        },
        infoText: vm.infoText,
        icon: require('../assets/home.png')
      })
      let center = {lat: lat, lng: lng}
      if (!vm.mensajero) {
        vm.center = {lat: lat, lng: lng}
      }
      if (vm.dibujarCirculos && vm.noDibujar) {
        vm.dibujarCirculos = false
        vm.$refs.myMap.resizePreserveCenter()
        if (!vm.servicio.compartido && !vm.servicio.agrupado && vm.quitarRadios) {
          vm.$http.get('https://mensajeria.guepardos.co/api/v2/franchises')
          .then(async response => {
            let valores = await vm.valoresRadios()
            valores.distancias[0].maximoKilometros = response.body[0].radio3
            valores.distancias[1].minimoKilometros = response.body[0].radio3
            valores.distancias[1].maximoKilometros = response.body[0].radio4
            valores.distancias[2].minimoKilometros = response.body[0].radio4
            valores.distancias[2].maximoKilometros = response.body[0].radio5
            valores.distancias[3].minimoKilometros = response.body[0].radio5
            valores.distancias[3].maximoKilometros = response.body[0].radio6
            valores.distancias[4].minimoKilometros = response.body[0].radio6
            valores.distancias[4].maximoKilometros = response.body[0].radio7
            let MarkerWithLabel = require('markerwithlabel')(google.maps)
            vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio1, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel)
            vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio2, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel)
            vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio3, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel)
            vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio4, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel)
            vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio5, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel)
            vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio6, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel)
            vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio7, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel)
            vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio8, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel)
          })
        }
      }
    },
    valoresRadios () {
      return this.$http.get(`https://mensajeria.guepardos.co/api/v2/valorRadios/${this.servicio.tarifa.numEntregas}`)
        .then(response => response.data)
    },
    dibujarMarkadorValor (lat, lng, distancia, valores, mapa, MarkerWithLabel) {
      let vm = this
      let meters = distancia * 1000
      meters = meters - 700
      let coef = meters * 0.0000089
      let coefDown = (meters + 600) * 0.0000089
      let newLng = lng + coef
      let newLat = lat + coef / Math.cos(lat * 0.018)
      let newLatDown = lat - coefDown / Math.cos(lat * 0.018)
      let valor = valores.distancias.find(function (item) {
        if (item.minimoKilometros <= distancia && item.maximoKilometros >= distancia) {
          return item
        }
      })
      valor = (vm.servicio.idaVuelta) ? valor.valorR : valor.valor
      valor = vm.formatNumber.new(valor)
      let homeLatLng = new google.maps.LatLng(newLat, lng)
      let homeLatLngDown = new google.maps.LatLng(newLatDown, lng)
      if (distancia > 0) {
        let marker1 = new MarkerWithLabel({
          position: homeLatLng,
          draggable: false,
          raiseOnDrag: false,
          map: mapa,
          icon: ' ',
          labelContent: 'Max. $' + valor,
          labelClass: 'labelsMarker', // the CSS class for the label
          labelStyle: {opacity: 1}
        })
        // vm.makersToRemove.push(marker1)
        let iw = new google.maps.InfoWindow({
          content: 'Entregas dentro del radio valen $' + valor
        })
        google.maps.event.addListener(marker1, 'click', function (e) { iw.open(mapa, this) })
        let marker2 = new MarkerWithLabel({
          position: homeLatLngDown,
          draggable: false,
          raiseOnDrag: false,
          map: mapa,
          icon: ' ',
          labelContent: 'Max. $' + valor,
          labelClass: 'labelsMarkerUp', // the CSS class for the label
          labelStyle: {opacity: 1}
        })
        // vm.makersToRemove.push(marker1)
        let iw2 = new google.maps.InfoWindow({
          content: 'Entregas dentro del radio valen $' + valor
        })
        google.maps.event.addListener(marker2, 'click', function (e) { iw2.open(mapa, this) })
        this.circles.push({
          center: {
            lat: lat,
            lng: lng
          },
          radius: (distancia) * 1000,
          visible: true
        })
      }
    },
    dibujarEntrega (lat, lng) {
      let vm = this
      this.markers.push({
        position: {
          lat: lat,
          lng: lng
        },
        infoText: `Entrega`,
        icon: require('../assets/entrega.png')
      })
      vm.distancia = vm.servicio.tarifa.distancia
      vm.valorKm = vm.servicio.tarifa.valorKm
      vm.showKm = true
      vm.showRd = false
      if (this.marcarRuta) {
        this.getRoute()
      }
    },
    dibujarMensajeros () {
      let vm = this
      vm.mensajeros = []
      vm._.forEach(vm.mensajerosData, function (mensajero) {
        vm.mensajeros.push({
          position: {
            lat: parseFloat(mensajero.ultimaPosicion.point.lat),
            lng: parseFloat(mensajero.ultimaPosicion.point.lng)
          },
          infoText: `${mensajero.nombre} - Placa: ${mensajero.placa} - Celular: ${mensajero.celular}`,
          icon: require('../assets/mensajero.png')
        })
      })
    },
    dibujarMensajeroAsignado () {
      let vm = this
      if (vm.lastPosition.latitude && vm.lastPosition.longitude) {
        let fotoUrl = (vm.mensajero.imagenPerfil) ? `https://storage.googleapis.com/gpds-web-storage/${vm.mensajero.imagenPerfil}` : vm.mensajero.foto
        vm.mensajeros = []
/*         if (vm.mensajero.imagenProfile) {
          vm.$http.get(`https://mensajeria.guepardos.co/api/v2/getImagenProfile/${vm.mensajero.imagenProfile}`)
            .then(data => {
              var icon = {
                url: 'data:' + vm.mensajero.imagenTipo + ';base64,' + data.body, // url
                scaledSize: new google.maps.Size(50, 50), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(0, 0) // anchor
              }
              vm.mensajeros.push({
                position: {
                  lat: parseFloat(vm.lastPosition.latitude),
                  lng: parseFloat(vm.lastPosition.longitude)
                },
                infoText: `${mensajero.nombre} - Placa: ${mensajero.placa} - Celular: ${mensajero.celular}`,
                icon: icon
              })
              vm.center = {
                lat: parseFloat(vm.lastPosition.latitude),
                lng: parseFloat(vm.lastPosition.longitude)
              }
              vm.zoom = 15
            })
        } else { */
        vm.mensajeros.push({
          position: {
            lat: parseFloat(vm.lastPosition.latitude),
            lng: parseFloat(vm.lastPosition.longitude)
          },
          infoText: `<div><img src="${fotoUrl}" style="display: block; margin: 0 auto;" width="150"/></div><div><strong>Nombre: </strong>${vm.mensajero.nombre}<br><strong>Placa: </strong>${vm.mensajero.placa} <br><strong>Celular: </strong>${vm.mensajero.celular}</div>`,
          icon: require('../assets/mensajero.png')
        })
        vm.center = {
          lat: parseFloat(vm.lastPosition.latitude),
          lng: parseFloat(vm.lastPosition.longitude)
        }
        vm.zoom = 15
      }
    },
    obtenerDirecciones () {
      let vm = this
      vm.entregasDirecciones = []
      if (vm.markers.length <= 10) {
        vm._.forEach(vm.markers, function (marker, index) {
          if (index >= 1) {
            let latlng = new google.maps.LatLng(marker.position.lat, marker.position.lng)
            let direccion = vm.googleDirecciones(latlng, index)
          }
        })
      } else {
        vm._.forEach(vm.markers, function (marker, index) {
          if (index >= 1) {
            marker.direccion = `Enterga ${index + 1}`
            marker.index = index + 1
            vm.entregasDirecciones.push(marker)
          }
        })
      }
    },
    googleDirecciones (latlng, index) {
      let vm = this
      let geocoder = new google.maps.Geocoder()
      geocoder.geocode({'latLng': latlng}, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          vm.markers[index].direccion = results[0].formatted_address
          vm.markers[index].index = index + 1
          vm.entregasDirecciones.push(vm.markers[index])
        } else {
          vm.googleDirecciones(latlng, index)
        }
      })
    },
    roundFormat (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals)
    },
    currencyFormat (value, decimals, symbol = '$ ') {
      return symbol + this.roundFormat(value, 2)
    },
    getRoute () {
      var vm = this
      vm.zoom = 13
      vm.marcarRuta = false
      vm.directionsService = new google.maps.DirectionsService()
      vm.directionsDisplay = new google.maps.DirectionsRenderer({
        'draggable': false,
        suppressMarkers: true
      })
      vm.directionsDisplay.setMap(vm.$refs.myMap.$mapObject)
      vm._.forEach(vm.markers, function (entrega, index) {
        vm.waypts.push({
          location: { 'lat': entrega.position.lat, 'lng': entrega.position.lng },
          stopover: true
        })
      })
      vm.directionsService.route({
        origin: new google.maps.LatLng(vm.markers[0].position.lat, vm.markers[0].position.lng),
        destination: new google.maps.LatLng(vm.markers[vm.markers.length - 1].position.lat, vm.markers[vm.markers.length - 1].position.lng),
        waypoints: vm.waypts,
        optimizeWaypoints: true,
        travelMode: 'DRIVING'
      }, function (response, status) {
        if (status === 'OK') {
          vm.directionsDisplay.setDirections(response)
          vm.$refs.myMap.resizePreserveCenter()
        } else {
          console.log('Directions request failed due to ' + status)
        }
      })
    },
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
    setRating () {
      let vm = this
      let inf = {
        calificacion: vm.rating
      }
      /* vm.$http.put(`https://evocloud-guepardos.appspot.com/api/servicios/${vm.servicio.id}`, inf)
          .then(data => {
            vm.showComment = true
          }) */
    }
  },
  computed: {
    tiempoServicio () {
      if (this.servicio.estadoServicio === 3) {
        let finalizado = this._.find(this.servicio.fechaHoraEstados, {'estado': 3})
        let a = moment(finalizado.fecha)
        let b = moment(this.servicio.fecha)
        let diff = a.diff(b, 'minutes')
        return `${diff} Minutos`
      } else {
        let a = moment()
        let b = moment(this.servicio.fecha)
        let diff = a.diff(b, 'minutes')
        return `${diff} Minutos`
      }
    },
    entregasSinRegresos () {
      let entregas = 0
      if (this.servicio.entregasMapa) {
        entregas = this.servicio.entregasMapa
      } else {
        entregas = this._.filter(this.servicio.fechaHoraEntregas, function (entrega) { return !entrega.regreso })
      }
      return entregas.length
    }
  },
  notifications: {
    notificacionRecogido: {
      title: 'Información',
      message: 'El servicio ha sido asigando y está en proceso de ser recogido.',
      type: 'info',
      timeout: 9000
    },
    notificacionMensajero: {
      title: 'Información',
      message: 'El mensajero tiene problemas de geolocalización.',
      type: 'info',
      timeout: 9000
    },
    notificacionBadPosition: {
      title: 'Información',
      message: 'El servicio cuenta con problemas en la geolocalización.',
      type: 'info',
      timeout: 9000
    }
  },
  watch: {
    comentario: _.debounce(function () {
      let vm = this
      let inf = {
        comentarioCalificacion: vm.comentario
      }
      /* vm.$http.put(`hhttps://evocloud-guepardos.appspot.com/api/servicios/${vm.servicio.id}`, inf)
          .then(data => {
            vm.servicio = data.body
          }) */
    }, 3000)
  },
  components: {
    StarRating
  }
}
</script>
<style>
.side-nav {
  position: fixed;
  width: 300px;
  left: 0;
  top: 0;
  margin: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  height: 100%;
  height: calc(100% + 60px);
  height: -moz-calc(100%);
  padding-bottom: 60px;
  background-color: #fff;
  z-index: 999;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow-y: auto;
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateX(-105%);
  transform: translateX(-105%);
}
.sizeA {
  color: #410099;
}
.marker {
  float: right;
  position: relative;
  padding-right: 5px;
  z-index: 1;
}
.gm-fullscreen-control {
  display: none;
}
.colorVerde {
    color: #5cb85c;
}
.conNav {
 height: 91vh;
}
.sinNav {
  height: 100vh;
}
.stroke {
  -webkit-text-stroke: 0.5px black;
  opacity: 0.8;
}
.purple.darken-4 {
    background-color: #410099 !important;
}
</style>



// WEBPACK FOOTER //
// Servicio.vue?972d32ba